import { type schemaType } from './schema'
import { type paramsType } from './paramsSchema'
import { API_INTERNAL_ENDPOINT } from './constants'

export type returnType = ApiServerResponse<schemaType>

export default async (params: paramsType): Promise<returnType> => {
  const runtimeConfig = useRuntimeConfig()

  const url = `${runtimeConfig.public.NUXT_API_CONTENT_ROOT_URL}/${API_INTERNAL_ENDPOINT}`

  const { data } = await useFetch(url, {
    body: {
      ...params,
    },
    method: 'POST',
  })

  return data.value as returnType
}
